// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';

import home from '@/views/home/home';

import buyList from '@/views/buyList/buyList';

import Vietnam from '@/views/Vietnam/Vietnam';

import Thailand from '@/views/Thailand/Thailand';

import Merchant from '@/views/Merchant/Merchant';

import personnel from '@/views/personnel/personnel';

import operator from '@/views/operator/operator';

import project from '@/views/project/project';

import category from '@/views/project/category';

import card from '@/views/card/card';

import vip from '@/views/vip/vip';

import vipLevel from '@/views/vip/vipLevel';

import vipCapacity from '@/views/vip/vipCapacity';




import vipDetail from '@/views/vip/vipDetail';

import goods from '@/views/shop/goods';

import lay from '@/views/shop/lay';

import section from '@/views/personnel/section';

import Cashier from '@/views/Cashier/Cashier';

//角色
import role from '@/views/operator/role';

import site from '@/views/arrange/site';

import arrange from '@/views/arrange/arrange';

import billboard from '@/views/billboard/billboard';
import recordDK from '@/views/billboard/recordDK';


import appointment from '@/views/appointment/appointment';

import setting from '@/views/setting/setting';

import SettingInfo from '@/views/setting/SettingInfo';
import OverallSettingInfo from '@/views/setting/OverallSettingInfo';
import PaySettingInfo from '@/views/setting/PaySettingInfo';
import SMSSettingInfo from '@/views/setting/SMSSettingInfo';
import TextSettingInfo from '@/views/setting/TextSettingInfo';
import board from '@/views/board/board';
import finance from '@/views/finance/finance';
import statistics from '@/views/statistics/statistics';
import customer from '@/views/vip/customer';
import renew from '@/views/vip/renew';
import birthday from '@/views/vip/birthday';
import phoneSetting from '@/views/phoneSetting/phoneSetting';
import notice from '@/views/notice/notice';
import photo from '@/views/photo/photo';
import delLesson from '@/views/arrange/delLesson';
import siteList from '@/views/site/siteList';
import siteMain from '@/views/site/siteMain';
import integral from '@/views/setting/integral';
import discoun from '@/views/discoun/discoun';
import appraise from '@/views/personnel/appraise';
import projectappraise from '@/views/project/appraise';
import SiteSetting from '@/views/setting/SiteSetting';
import siteMainList from '@/views/site/siteMainList';
import siteMainSHList from '@/views/site/siteMainSHList';


/**
 * 基础菜单
 */
// 商品管理

import MachineConfig from '@/views/machine/MachineConfig';



// 启用路由
import SeckillAcinfo from '@/views/marketing/SeckillAcinfo';
import LadderSpellGroupAcinfo from '@/views/marketing/LadderSpellGroupAcinfo';

Vue.use(Router);

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
  
     {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'li-icon-xiangmuguanli',
        children: [{
            path: '/home/home',
            name: '工作台',
            component: home,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/buyList/buyList',
            name: '购买记录',
            component: buyList,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/Vietnam/Vietnam',
            name: '越南客户',
            component: Vietnam,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/Thailand/Thailand/:id',
            name: '门店',
            component: Thailand,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/shop/goods',
            name: '商品列表',
            component: goods,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/shop/lay',
            name: '商品列表',
            component: lay,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/Merchant/Merchant',
            name: '商户列表',
            component:Merchant,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/personnel/personnel',
            name: '用户列表',
            component:personnel,
            meta: {
                requireAuth: true
            },
        },

        {
            path: '/personnel/section',
            name: '用户部门',
            component: section,
            meta: {
                requireAuth: true
            },
        },
      
        {
            path: '/operator/operator/:id',
            name: '操作员列表',
            component:operator,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/operator/role/:id',
            name: '角色列表',
            component:role,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/project/project',
            name: '项目列表',
            component:project,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/project/category',
            name: '项目类别',
            component:category,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/card/card',
            name: '会员卡列表',
            component:card,
            meta: {
                requireAuth: true
            },
            
        },
        {
                path: '/machine/MachineConfig',
                name: '前台收银',
                component: MachineConfig,
                meta: {
                    requireAuth: true
                }
            },
        {
            path: '/vip/vip',
            name: '会员列表',
            component:vip,
            meta: {
                requireAuth: true
            },
            
        },
        {
            path: '/project/appraise/:id',
            name: '项目评价',
            component:projectappraise,
            meta: {
                requireAuth: true
            },

        },
        {
            path: '/personnel/appraise/:id',
            name: '员工评价',
            component:appraise,
            meta: {
                requireAuth: true
            },

        },
        {
            path: '/vip/vipLevel',
            name: '会员等级',
            component:vipLevel,
            meta: {
                requireAuth: true
            },
           
            
        }, {
            path: '/vip/vipCapacity',
            name: '能力等级',
            component:vipCapacity,
            meta: {
                requireAuth: true
            },
           
            
        },

        
        {
            path: '/vip/vipDetail/:id',
            name: '会员详情',
            component:vipDetail,
            meta: {
                requireAuth: true
            },

        },
        {
            path: '/photo/photo/:id',
            name: '照片墙',
            component:photo,
            meta: {
                requireAuth: true
            },

        },
        {
            path: '/discoun/discoun',
            name: '优惠券',
            component: discoun,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/arrange/arrange',
            name: '排班',
            component:arrange,
            meta: {
                requireAuth: true
            },

        },
        {
            path: '/arrange/site/:id',
            name: '场地',
            component:site,
            meta: {
                requireAuth: true
            },

        },
        {
            path: '/billboard/billboard',
            name: '看板',
            component:billboard,
            meta: {
                requireAuth: true
            },

        },
        {
            path: '/billboard/recordDK',
            name: '打卡',
            component:recordDK,
            meta: {
                requireAuth: true
            },

        },
        
        {
            path: '/appointment/appointment',
            name: '预约情况',
            component:appointment,
            meta: {
                requireAuth: true
            },

        },
        {
            path: '/setting/setting',
            name: '预约情况',
            component:setting,
            meta: {
                requireAuth: true
            },

        },{
            path: '/setting/SettingInfo/:id',
            name: '基础配置',
            component:SettingInfo,
            meta: {
                requireAuth: true
            },

        },{
            path: '/setting/SiteSetting/:id',
            name: '场地配置',
            component:SiteSetting,
            meta: {
                requireAuth: true
            },

        },
        
        
        {
            path: '/setting/OverallSettingInfo/:id',
            name: '全局配置',
            component:OverallSettingInfo,
            meta: {
                requireAuth: true
            },

        },{
            path: '/setting/PaySettingInfo/:id',
            name: '支付配置',
            component:PaySettingInfo,
            meta: {
                requireAuth: true
            },

        },{
            path: '/setting/SMSSettingInfo/:id',
            name: '短息配置',
            component:SMSSettingInfo,
            meta: {
                requireAuth: true
            },

        },{
            path: '/setting/TextSettingInfo/:id',
            name: '文字配置',
            component:TextSettingInfo,
            meta: {
                requireAuth: true
            },

        },
        {
            path: '/arrange/delLesson/:id',
            name: '批量删除',
            component:delLesson,
            meta: {
                requireAuth: true
            },

        },
        {
            path: '/Cashier/Cashier',
            name: '收银管理',
            component:Cashier,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/finance/finance',
            name: '财务',
            component:finance,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/board/board',
            name: '看板',
            component:board,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/statistics/statistics',
            name: '统计',
            component:statistics,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/vip/customer',
            name: '意向客户',
            component:customer,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/vip/renew',
            name: '续期预警',
            component:renew,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/vip/birthday',
            name: '生日提醒',
            component:birthday,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/phoneSetting/phoneSetting/:id',
            name: '手机端设置',
            component:phoneSetting,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/notice/notice',
            name: '通知/公告',
            component:notice,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/site/siteList',
            name: '场地',
            component:siteList,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/site/siteMain',
            name: '场地详情',
            component:siteMain,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/site/siteMainList',
            name: '预约详情',
            component:siteMainList,
            meta: {
                requireAuth: true
            },
        },{
            path: '/site/siteMainSHList',
            name: '取消审核',
            component:siteMainSHList,
            meta: {
                requireAuth: true
            },
        },
        
        {
            path: '/marketing/SeckillAcinfo',
            name: '秒杀活动',
            component:SeckillAcinfo,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/marketing/LadderSpellGroupAcinfo',
            name: '拼团活动',
            component:LadderSpellGroupAcinfo,
            meta: {
                requireAuth: true
            },
        },
        {
            path: '/setting/integral/:id',
            name: '积分',
            component: integral,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
      
        // }, {
        //     path: '/machine/Machine',
        //     name: '机器信息管理',
        //     component: Machine,
        //     meta: {
        //         requireAuth: true
        //     }
        // }, {
        //     path: '/machine/MachineAisle',
        //     name: '货道信息管理',
        //     component: MachineAisle,
        //     meta: {
        //         requireAuth: true
        //     }
        // }, {
        //     path: '/pay/Order',
        //     name: '交易订单',
        //     component: Order,
        //     meta: {
        //         requireAuth: true
        //     }
        // }, {
        //     path: '/system/user',
        //     name: '用户管理',
        //     component: user,
        //     meta: {
        //         requireAuth: true
        //     }
        // }, {
        //     path: '/system/Module',
        //     name: '菜单管理',
        //     component: Module,
        //     meta: {
        //         requireAuth: true
        //     }
        // }, {
        //     path: '/system/Role',
        //     name: '角色管理',
        //     component: Role,
        //     meta: {
        //         requireAuth: true
        //     }
        // }, {
        //     path: '/system/Dept',
        //     name: '公司管理',
        //     component: Dept,
        //     meta: {
        //         requireAuth: true
        //     }
        // }, {
        //     path: '/system/Variable',
        //     name: '系统环境变量',
        //     component: Variable,
        //     meta: {
        //         requireAuth: true
        //     }
        // }, {
        //     path: '/system/Permission',
        //     name: '权限管理',
        //     component: Permission,
        //     meta: {
        //         requireAuth: true
        //     }
        // }, {
        //     path: '/machine/MachineConfig',
        //     name: '支付配置信息',
        //     component: MachineConfig,
        //     meta: {
        //         requireAuth: true
        //     }
        // }, {
        //     path: '/pay/Config',
        //     name: '支付配置',
        //     component: Config,
        //     meta: {
        //         requireAuth: true
        //     }
        // }, {
        //     path: '/druid/login',
        //     name: '监控查询',
        //     component: druidLogin,
        //     meta: {
        //         requireAuth: true
        //     }
        // }, {
        //     path: '/charts/statistics',
        //     name: '数据可视化',
        //     component: statistics,
        //     meta: {
        //         requireAuth: true
        //     }
      ]
        
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js